const checkCourseApplication = (answers, currentQuestion, setCourseApplication) => {
    const currentAnswer = answers.hasOwnProperty(currentQuestion) ? answers[currentQuestion] : null;

    if (currentAnswer) {
        if (currentAnswer.courseApplication) {
            setCourseApplication(true);
        }
    }
};

export { checkCourseApplication };
